export default "/images/34c796f3f3340a3d0895fdbe2b221aa5.avif";